import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {io} from 'socket.io-client';
import GoogleMapReact from 'google-map-react';
import {Spin, Menu, message} from 'antd';
import {toggleFollowVehicle, setZoom, setMapCenter} from '../../../slices/mapSlice';
import {toggleRightButton, toggleMapButton} from "../../../slices/mapSettingSlice";
import MapMarker from './MapMarker';
import {useNavigate} from 'react-router-dom';
import MapSideBar from './MapSideBar';
import HistoryMap from './HistoryMap';
import MapSidebarRight from "./MapSideBarRight";
import DateTimeModal from "../../../components/DateTimeModal";

const Index = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {user} = useSelector((state) => state.auth);
    const rightButton = useSelector((state) => state.mapSettings.rightButton);
    const {zoom, center, followVehicle} = useSelector((state) => state.map);
    const {mapType} = useSelector((state) => state.mapSettings);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [contextMenuVisible, setContextMenuVisible] = useState(false);
    const [contextMenuPosition, setContextMenuPosition] = useState({x: 0, y: 0});
    const [contextMenuVehicle, setContextMenuVehicle] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [selectedOnlineStatuses, setSelectedOnlineStatuses] = useState([]);
    const [selectedFuelType, setSelectedFuelType] = useState([]);
    const [selectedIgnitionType, setSelectedIgnitionType] = useState([]);
    const [selectedGroupTitle, setSelectedGroupTitle] = useState([]);
    const [selectedBrandType, setSelectedBrandType] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    const [isDateTimeModalVisible, setIsDateTimeModalVisible] = useState(false);
    const [customDateRange, setCustomDateRange] = useState([]);

    const [historyMode, setHistoryMode] = useState(false);
    const [timeRange, setTimeRange] = useState(null);


    const connectSocket = () => {
        setLoading(true);
        const socket = io('https://live.myoctoopidev.com', {
            reconnection: true,
            transports: ['websocket'],
            reconnectionDelay: 2000,
            reconnectionAttempts: 5,
            withCredentials: true,
            query: {
                'x-access-token': user?.token,
            },
            transportOptions: {
                binary: true,
            },
        });


        socket.on('map', async (incomingData) => {
            setLoading(false);
            setData(incomingData)
        });

        socket.on('reconnect', (event) => {
            console.log('Yeniden bağlandınız');
            console.log('Olay => ', event);
        });

        socket.on('connect_error', (error) => {
            console.log(error.name);
        });

        return () => {
            socket.disconnect();
        };
    };

    useEffect(() => {
        connectSocket();
    }, [user?.token]);

    useEffect(() => {
        const results = data.filter((item) => {
            const matchesSearchTerm =
                searchTerm.length === 0 ||
                item.plateNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.operationNumber?.toLowerCase().includes(searchTerm.toLowerCase());

            const matchesStatus =
                selectedStatuses.length === 0 ||
                selectedStatuses.includes(item.status);

            const matchesOnlineStatus =
                selectedOnlineStatuses.length === 0 ||
                selectedOnlineStatuses.includes(item.onlineStatus);

            const matchesGroupTitle =
                selectedGroupTitle.length === 0 ||
                selectedGroupTitle.includes(item.groupTitle);

            const matchesBrand =
                !selectedBrandType || selectedBrandType.length === 0 ||
                (item.brand && selectedBrandType.includes(item.brand));

            const matchesFuelType =
                !selectedFuelType || selectedFuelType.length === 0 ||
                (item.fuelType && selectedFuelType.includes(item.fuelType));

            const matchesIgnitionType =
                !selectedIgnitionType ||
                selectedIgnitionType.length === 0 ||
                (item.cruiseStatus &&
                    selectedIgnitionType.includes(item.cruiseStatus));

            return (
                matchesSearchTerm &&
                matchesStatus &&
                matchesOnlineStatus &&
                matchesBrand &&
                matchesFuelType &&
                matchesIgnitionType &&
                matchesGroupTitle
            );
        });

        setSearchResults(results);
    }, [
        data,
        searchTerm,
        selectedStatuses,
        selectedOnlineStatuses,
        selectedBrandType,
        selectedFuelType,
        selectedIgnitionType
    ]);

    const handleMarkerClick = (vehicleId) => {
        setSelectedVehicle(vehicleId);
        if (rightButton === false) {
            dispatch(toggleRightButton(true))
        }
        const selectedVehicleData = data && data.find((item) => item.vehicle_id === vehicleId);
        if (selectedVehicleData?.gps) {
            const center = {lat: selectedVehicleData.gps.lat, lng: selectedVehicleData.gps.lon};
            dispatch(setMapCenter(center));
            dispatch(setZoom(21));
        }
    };

    const handleDateTimeSubmit = () => {
        if (customDateRange && customDateRange.length === 2) {
            const [startDate, endDate] = customDateRange;
            setSelectedVehicle(contextMenuVehicle);
            setHistoryMode(true);
            setTimeRange({startDate, endDate});
            setIsDateTimeModalVisible(false);
        } else {
            message.error('Geçerli bir tarih aralığı seçin.');
        }
    };

    const handleContextMenu = (event, vehicleId) => {
        event.preventDefault();
        setContextMenuVehicle(vehicleId);
        setContextMenuPosition({x: event.clientX, y: event.clientY});
        setContextMenuVisible(true);
    };

    const handleMenuClick = (e) => {
        setContextMenuVisible(false);
        switch (e.key) {
            case 'follow':
                setSelectedVehicle(contextMenuVehicle);
                dispatch(toggleFollowVehicle(true));
                break;
            case 'mapsetting':
                dispatch(toggleMapButton(true))
                break;
            case 'details':
                navigate(`/live/${contextMenuVehicle}/1`);
                break;
            case 'stop':
                navigate(`/live/${contextMenuVehicle}/4`);
                break;
            case 'report':
                navigate(`/live/${contextMenuVehicle}/2`);
                break;
            case 'history-1h':
            case 'history-2h':
            case 'history-3h':
            case 'history-4h':
            case 'history-5h':
            case 'today':
            case 'yesterday':
                setSelectedVehicle(contextMenuVehicle);
                setHistoryMode(true);
                setTimeRange(e.key);
                break;
            case 'customDate':
                setIsDateTimeModalVisible(true);
                setSelectedVehicle(contextMenuVehicle);
                setCustomDateRange()
                setHistoryMode(true);
                break;
            default:
                break;
        }
    };

    const historyMenu = (
        <Menu onClick={handleMenuClick}>
            <Menu.Item key="history-1h">Son 1 Saat</Menu.Item>
            <Menu.Item key="history-2h">Son 2 Saat</Menu.Item>
            <Menu.Item key="history-3h">Son 3 Saat</Menu.Item>
            <Menu.Item key="history-4h">Son 4 Saat</Menu.Item>
            <Menu.Item key="history-5h">Son 5 Saat</Menu.Item>
            <Menu.Item key="today">Bugün</Menu.Item>
            <Menu.Item key="yesterday">Dün</Menu.Item>
            <Menu.Item key="customDate">Tarih gir</Menu.Item>
        </Menu>
    );


    const menu = (
        <Menu onClick={handleMenuClick}>
            <Menu.Item key="details">Araç izleme</Menu.Item>
            <Menu.Item key="mapsetting">Harita Ayarları</Menu.Item>
            <Menu.Item key="stop">Arıza detay özeti</Menu.Item>
            <Menu.Item key="report">Araç uyarıları</Menu.Item>
            <Menu.SubMenu key="history" title="Araç Geçmişi">
                {historyMenu}
            </Menu.SubMenu>
        </Menu>
    );

    useEffect(() => {
        const handleClickOutside = () => {
            if (contextMenuVisible) {
                setContextMenuVisible(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [contextMenuVisible]);

    const handleExitHistoryMode = () => {
        setHistoryMode(false);
        setSelectedVehicle(null);
        window.location.reload();
    };

    if (!data || loading) return (
        <div style={{
            position: 'relative',
            width: '100%',
            height: 'calc(100vh - 5.1em)'
        }}>
            <div
                style={{
                    height: "calc(100vh - 5.1em)",
                    width: "100%",
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    opacity: loading ? 0.5 : 1,
                }}
            >
                <GoogleMapReact
                    bootstrapURLKeys={{key: 'AIzaSyC-SvUIH5jgmfFvb5DXjuawroi1CG134ZA'}}
                    center={center}
                    zoom={zoom}
                    options={mapType}
                    yesIWantToUseGoogleMapApiInternals
                />
            </div>
            <Spin
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
                size="normal"
            />
        </div>
    );


    return (
        <div className="app-container">
            <div
                style={{
                    height: 'calc(100vh - 4.6em)',
                    width: '100%',
                    boxSizing: 'border-box',
                    position: 'relative',
                }}
            >
                {!historyMode ? (
                    <GoogleMapReact
                        bootstrapURLKeys={{key: 'AIzaSyAfTmRq-qL0rfjCZDRvKUfl8afwyXRFinQ'}}
                        center={center}
                        zoom={zoom}
                        defaultZoom={zoom}
                        options={{
                            gestureHandling: 'greedy',
                            disableDefaultUI: true,
                            mapId: 'YOUR_MAP_ID',
                            mapTypeId: mapType,
                        }}
                        onDragEnd={() => {
                            if (followVehicle) {
                                dispatch(toggleFollowVehicle(false));
                            }
                        }}
                    >
                        {searchResults.map((item, index) =>
                            item.gps?.lat && item.gps?.lon ? (
                                <MapMarker
                                    key={index}
                                    cruiseStatus={item.cruiseStatus}
                                    status={item.status}
                                    operationNumber={item.operationNumber}
                                    position={{lat: item.gps.lat, lng: item.gps.lon}}
                                    plateNumber={item.plateNumber}
                                    deviceId={item.vehicle_id}
                                    chassisNumber={item.chassisNumber}
                                    onClick={() => handleMarkerClick(item.vehicle_id)}
                                    onContextMenu={(event) => handleContextMenu(event, item.vehicle_id)}
                                    lat={item.gps.lat}
                                    lng={item.gps.lon}
                                />
                            ) : null
                        )}
                    </GoogleMapReact>
                ) : (
                    <HistoryMap vehicleId={selectedVehicle} timeRange={timeRange} onExit={handleExitHistoryMode}/>
                )}
                {contextMenuVisible && (
                    <div
                        style={{
                            position: 'absolute',
                            top:
                                contextMenuPosition.y + 300 > window.innerHeight
                                    ? contextMenuPosition.y - 300
                                    : contextMenuPosition.y,
                            left:
                                contextMenuPosition.x + 150 > window.innerWidth
                                    ? contextMenuPosition.x - 150
                                    : contextMenuPosition.x,
                            zIndex: 1000,
                            backgroundColor: 'white',
                            boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
                        }}
                    >
                        {menu}
                    </div>
                )}
                {!historyMode && (
                    <>
                        <MapSideBar
                            vehicles={data}
                            onVehicleSelect={(lat, lng, zoom) => {
                                dispatch(setZoom(zoom));
                                dispatch(setMapCenter({lat, lng}));
                            }}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            selectedStatuses={selectedStatuses}
                            setSelectedStatuses={setSelectedStatuses}
                            selectedOnlineStatuses={selectedOnlineStatuses}
                            setSelectedOnlineStatuses={setSelectedOnlineStatuses}
                            selectedBrandType={selectedBrandType}
                            setSelectedBrandType={setSelectedBrandType}
                            selectedFuelType={selectedFuelType}
                            setSelectedFuelType={setSelectedFuelType}
                            selectedIgnitionType={selectedIgnitionType}
                            setSelectedIgnitionType={setSelectedIgnitionType}
                            selectedGroupTitle={selectedGroupTitle}
                            setSelectedGroupTitle={setSelectedGroupTitle}
                        />
                        <MapSidebarRight vehicleId={selectedVehicle}/>
                    </>
                )}
            </div>
            <div>
                <DateTimeModal
                    handleDateTimeSubmit={handleDateTimeSubmit}
                    isDateTimeModalVisible={isDateTimeModalVisible}
                    setIsDateTimeModalVisible={setIsDateTimeModalVisible}
                    setCustomDateRange={setCustomDateRange}
                />
            </div>
        </div>
    );
};

export default Index;
